import { getImageSourceUrl, setFacebookShareMates, getCountry, formatStringToURL } from '@/plugins/utils'

const getFirstSpec = (listing: ProductV3.ListingDetailV3) => listing.specs.map(c => `${c.name}-${c.values[0]?.value || ''}`) // .join('-')
const formatSeoStr = (listing: ProductV3.ListingDetailV3, str: string, addSpec = false): string => {
  const categoryName = listing.categoriesPath[listing.categoriesPath.length - 1].name
  const firstSpec = getFirstSpec(listing).join(' ') // .specs.map(c => `${c.name}-${c.values[0]?.value || ''}`).join('-')

  let _title = `${listing.title} ${firstSpec} ${listing.listingId}`
  if(!addSpec) {
    _title = listing.title
  }

  return str
    .replaceAll('$[productTitle]', _title)
    .replaceAll('$[productSubCategory]', String(categoryName || ''))
}

// 长标题： mate title / title 加规格， 
// 短标题： 

/**
 * SEO meta 设置
 * @param listing 商品详情
 */
export const setSEOMeta = (listing: ProductV3.ListingDetailV3, skuPrice: ProductV2.ISkuPrice) => {
  const currentHost = useCurrentHost()
  useHead({
    link: [
      {
        rel: "canonical",
        href: `${currentHost}/listing/${listing.listingId}-${formatStringToURL(listing.shortTitle || listing.title)}`
        // -${getFirstSpec(listing)}
      }
    ]
  })

  /** Facebook 分享 */
  setFacebookShareMates({
    title: listing.title,
    image: getImageSourceUrl(listing.imageUrl),
    description: `🌟 Only KSh ${skuPrice?.salePrice || skuPrice?.listPrice} for this amazing product on Kilimall! Check it out and enjoy quality shopping today! 🛒✨`, // formatSeoStr(metaDescription),
    url: `${currentHost}${useRoute().fullPath}`,
    type: 'product',
    'product:price:amount': String(skuPrice.salePrice || ''),
    'product:price:currency': getCountry().currency
  })

  const seoConfig = useGlobalJsonData().value.seo?.data

  if (!seoConfig?.productDetail) { return }

  const {
    title: seoTitle = '',
    metaDescription = '',
    metaKeywords = '',
    metaTitle = ''
  } = seoConfig.productDetail || {}

  useHead({
    title: formatSeoStr(listing, seoTitle, true),
    meta: [
      { name: 'description', content: formatSeoStr(listing, metaDescription) },
      { name: 'keywords', content: formatSeoStr(listing, metaKeywords) },
      { name: 'title', content: formatSeoStr(listing, metaTitle, true) },
    ]
  })
}

/**
 * Google 结构化数据（基于 /goods-google-structured-data 接口）
 * @param apiData 接口返回的完整 JSON-LD 结构（含 @context、@type、mainEntity）
 * @param structuredItems 面包屑导航数据
 */
export const setStructuredData = (
  apiData: any,
  structuredItems: { name: string, position: number, item: string, '@type': 'ListItem' }[]
) => {
  if (!apiData?.mainEntity) {
    console.warn('[setStructuredData] apiData.mainEntity is empty, skip structured data injection')
    return
  }
  const currentHost = useCurrentHost()

  const breadcrumbList = [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@id": `${currentHost}/`,
        "name": "Home"
      }
    },
    ...structuredItems.map(item => ({
      "@type": "ListItem",
      "position": item.position,
      "item": {
        "@id": item.item,
        "name": item.name
      }
    }))
  ]

  const structuredData = {
    ...apiData,
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbList
    }
  }

  useHead({
    script: [
      {
        key: 'listing-structured-data',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(structuredData)
      }
    ]
  })
}
